<script>
    import { getContext } from 'svelte'

    export let to
    const ctx = getContext('section')
    
</script>
{#if to === 'user'}
    <button class="our blue"    on:click = { e => ctx.asUser() } disabled={to === 'dpo' } > ver como titular </button>
{:else}
    <button class="our purple"  on:click = { e => ctx.asDPO()  } disabled={to === 'user'} > ver como dpo     </button>
{/if}
